module.exports = __webpack_public_path__ + "static/Thumb_NC1_Tatoo_Breakdown_comp-ed6000551d765670c6104b6e95a768f6.png";